// Zentrale Konfigurationsdatei für umgebungsabhängige Einstellungen

// Umgebungsvariablen ausgeben (zur Fehlerbehebung)
console.log('NODE_ENV:', process.env.NODE_ENV);
console.log('VUE_APP_ENV:', process.env.VUE_APP_ENV);

// Erkennung der Entwicklungsumgebung
const isDevelopment = () => {
  return process.env.NODE_ENV === 'development' || process.env.VUE_APP_ENV === 'development';
};

// API-URLs
const apiBaseUrl = "process.env.VUE_APP_API_URL" || "https://dev.backend.der-lagermeister.de";

// Weitere Konfigurationen können hier hinzugefügt werden
const config = {
  isDevelopment: isDevelopment(),
  apiBaseUrl,
  version: '0.9.0',
  appName: 'LMS Order',
  environment: process.env.VUE_APP_ENV || process.env.NODE_ENV
};

console.log('isDevelopment:', config.isDevelopment);

export default config;